import { render, staticRenderFns } from "./ResetButton.vue?vue&type=template&id=3976b053"
import script from "./ResetButton.vue?vue&type=script&lang=ts"
export * from "./ResetButton.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\ldemenego\\REPOS\\VUEJS\\configuratore-demenego-v2\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3976b053')) {
      api.createRecord('3976b053', component.options)
    } else {
      api.reload('3976b053', component.options)
    }
    module.hot.accept("./ResetButton.vue?vue&type=template&id=3976b053", function () {
      api.rerender('3976b053', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/buttons/ResetButton.vue"
export default component.exports